import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { translate } from 'react-i18next';

import { formatNumber, formatLargeNumber } from '../../service/market';

import css from '../../styles/instrument/summary';

moment.locale('sv');

class Summary extends Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
        TIME: PropTypes.number,
        OPEN: PropTypes.number,
        VOLUME: PropTypes.number,
        HIGH: PropTypes.number,
        LOW: PropTypes.number,
        TURNOVER: PropTypes.number,
        BID: PropTypes.number,
        ASK: PropTypes.number,
        MARKET_CAP_ROUNDED: PropTypes.number,
    }

    constructor(props) {
        super(props);

        this._renderTime = prop => {
            const dateFormat = moment(this.props[prop]).isSame(moment().startOf('day'), 'd') ?
                'HH:mm:ss' : 'DD. MMM';

            return moment(this.props[prop]).format(dateFormat);
        };

        this._renderProp = prop => formatNumber(this.props[prop]);

        this._renderLargeNumber = prop => {
            const number = this.props[prop];

            const decimals = number >= 1e6 ? 1 : 0;

            return formatLargeNumber(number, decimals);
        };
    }

    getFields() {
        const { t, TURNOVER, VOLUME, MARKET_CAP_ROUNDED, BID, ASK, HIGH, LOW } = this.props;

        const time = [t('date:time'), 'TIME', this._renderTime];
        const open = [t('opening'), 'OPEN', this._renderProp];
        const volume = [t('volume'), 'VOLUME', this._renderLargeNumber];
        const high = [t('high'), 'HIGH', this._renderProp];
        const low = [t('low'), 'LOW', this._renderProp];
        const turnover = [t('turnover'), 'TURNOVER', this._renderLargeNumber];
        const bid = [t('bid'), 'BID', this._renderProp];
        const ask = [t('ask'), 'ASK', this._renderProp];
        const market = [t('marketValue'), 'MARKET_CAP_ROUNDED', this._renderLargeNumber];

        const fields = [time];

        if (!TURNOVER && !VOLUME && !MARKET_CAP_ROUNDED) {
            fields.push(bid, ask, open, high, low);
        } else {
            fields.push(open, volume);
            if (HIGH || LOW || TURNOVER) {
                fields.push(high, low, turnover);
            }
            if (BID || ASK || MARKET_CAP_ROUNDED) {
                fields.push(bid, ask, market);
            }
        }

        return fields;
    }

    renderContent() {
        const rows = [];

        const fields = this.getFields();

        for (const [name, prop, handler] of fields) {
            rows.push(
                <div className={css.entry} key={prop}>
                    <span className={css.heading}> {name}</span>
                    {this.props[prop] ?
                        <span>{handler(prop)}</span> : <span className={css.muted}>-</span>
                    }
                </div>
            );
        }

        return rows;
    }

    render() {
        return (
            <div className={css.container}>
                <div className={css.list}>
                    {this.renderContent()}
                </div>
            </div>
        );
    }
}

export default translate('common')(Summary);



/** WEBPACK FOOTER **
 ** /src/shared/components/instrument/Summary.js
 **/